import { App } from "App";
import React from "react";
import ReactDOM from "react-dom";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import "./_index.scss";
import thunk from "redux-thunk";
import registerServiceWorker from "./registerServiceWorker";
import { Provider } from "react-redux";
import { BrowserRouter, Route } from "react-router-dom";
import { createStore, applyMiddleware, compose } from "redux";
import { keys } from './stripeValues';

const { Api } = require("./api");
const { rootReducer } = require("./reducers");
const { initialize } = require("./actions/initializers");

const api = new Api();
const composeEnhancers =
  process.env.NODE_ENV === "production"
    ? compose
    : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk.withExtraArgument({ api })))
);

store.dispatch(initialize(store));

const stripePromise = loadStripe(keys[process.env.REACT_APP_ENV]);

ReactDOM.render(
  <Provider store={store}>
    <Elements stripe={stripePromise}>
      <BrowserRouter basename={process.env.REACT_APP_BASE_PATH}>
        <Route component={App} />
      </BrowserRouter>
    </Elements>
  </Provider>,
  document.getElementById("root")
);

if (module.hot) {
  module.hot.accept("./reducers", () => store.replaceReducer(rootReducer));
}

registerServiceWorker();
